var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stories"},[_c('background',{attrs:{"item":_vm.item,"theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }